import {
  createAsyncActions,
  runAsyncWorkflow
} from '../lib/reduxHelpers';
import { StemProgram } from '../api';


export const [
  fetchLessonPlans,
  receiveLessonPlans,
  fetchLessonPlansError
] = createAsyncActions(
  'LESSON_PLANS',
  () => {},
  ({ data }) => ({ data  })
);

export const getAllLessonPlansWorkFlow = (subject, grade, locale) => {
  const fetchPromise = StemProgram.getAllLessonPlans(subject, grade, locale);

  return runAsyncWorkflow({
    fetch: fetchLessonPlans,
    receive: receiveLessonPlans,
    error: fetchLessonPlansError
  }, fetchPromise)
};


export const [
  fetchLessonPlansWithTag,
  receiveLessonPlansWithTag,
  fetchLessonPlansWithTagError
] = createAsyncActions(
  'LESSON_PLANS_WITH_TAG',
  () => {},
  ({ data }) => ({ data  })
);

export const getAllLessonPlansWithTagWorkFlow = (tag, locale) => {
  const fetchPromise = StemProgram.getAllLessonPlansWithTag(tag, locale);

  return runAsyncWorkflow({
    fetch: fetchLessonPlansWithTag,
    receive: receiveLessonPlansWithTag,
    error: fetchLessonPlansWithTagError
  }, fetchPromise)
};

export const [
  fetchStemTagStaticData,
  receiveStemTagStaticData,
  fetchStemTagStaticDataError
] = createAsyncActions(
  'STATIC_DATA_TAG',
  () => {},
  ({ data }) => ({ data  })
);

export const getStemTagStaticDataWorkFlow = (locale) => {
  const fetchPromise = StemProgram.getStemTagStaticData(locale);

  return runAsyncWorkflow({
    fetch: fetchStemTagStaticData,
    receive: receiveStemTagStaticData,
    error: fetchStemTagStaticDataError
  }, fetchPromise)
};

export const [
  fetchLessonPlanData,
  receiveLessonPlanData,
  fetchLessonPlanDataError
] = createAsyncActions(
  'GET_LP_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getLessonPlanDataWorkFlow= (id) => {
  const fetchPromise = StemProgram.getLessonPlanData(id);

  return runAsyncWorkflow({
    fetch: fetchLessonPlanData,
    receive: receiveLessonPlanData,
    error: fetchLessonPlanDataError
  }, fetchPromise)
};

export const [
  fetchLpStaticData,
  receiveLpStaticData,
  fetchLpStaticDataError
] = createAsyncActions(
  'GET_LP_STATIC_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getLpStaticDataWorkFlow= (locale) => {
  const fetchPromise = StemProgram.getLpStaticData(locale);

  return runAsyncWorkflow({
    fetch: fetchLpStaticData,
    receive: receiveLpStaticData,
    error: fetchLpStaticDataError
  }, fetchPromise)
};

export const [
  fetchBooksForLp,
  receiveBooksForLp,
  fetchBooksForLpError
] = createAsyncActions(
  'GET_BOOKS_FOR_LP',
  () => {},
  ({ data }) => ({ data  })
);

export const getBooksForLpWorkFlow= (books, pledge) => {
  const fetchPromise = StemProgram.getBooksForLp(books, pledge);

  return runAsyncWorkflow({
    fetch: fetchBooksForLp,
    receive: receiveBooksForLp,
    error: fetchBooksForLpError
  }, fetchPromise)
};

export const [
  fetchLpFromSkillSet,
  receiveLpFromSkillSet,
  fetchLpFromSkillSetError
] = createAsyncActions(
  'GET_LP_SKILL_SET',
  () => {},
  ({data}) => ({data})
);

export const getLpFromSkillSetWorkFlow= (skill, grade, subject) => {
  const fetchPromise = StemProgram.getLpFromSkillSet(skill, grade, subject);

  return runAsyncWorkflow({
    fetch: fetchLpFromSkillSet,
    receive: receiveLpFromSkillSet,
    error: fetchLpFromSkillSetError
  }, fetchPromise)
};

export const [
  fetchLpFromBookId,
  receiveLpFromBookId,
  fetchLpFromBookIdError
] = createAsyncActions(
  'GET_LP_FROM_BOOK_ID',
  () => {},
  ({data}) => ({data})
);

export const getLpFromBookIdWorkFlow = (id) => {
  const fetchPromise = StemProgram.getLpFromBookId(id);

  return runAsyncWorkflow({
    fetch: fetchLpFromBookId,
    receive: receiveLpFromBookId,
    error: fetchLpFromBookIdError
  }, fetchPromise)
};

export const [
  fetchStemStaticData,
  receiveStemStaticData,
  fetchStemStaticDataError
] = createAsyncActions(
  'GET_STATIC_STEM_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getStemStaticDataWorkFlow= (locale) => {
  const fetchPromise = StemProgram.getStemStaticData(locale);

  return runAsyncWorkflow({
    fetch: fetchStemStaticData,
    receive: receiveStemStaticData,
    error: fetchStemStaticDataError
  }, fetchPromise)
};

export const [
  fetchStemTagSearchData,
  receiveStemTagSearchData,
  fetchStemTagSearchError
] = createAsyncActions(
  'GET_STEM_SEARCH_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getStemTagSearchData = (query, locale) => {
  const fetchPromise = StemProgram.getStemTagSearchData(query, locale);

  return runAsyncWorkflow({
    fetch: fetchStemTagSearchData,
    receive: receiveStemTagSearchData,
    error: fetchStemTagSearchError
  }, fetchPromise)
};

export const [
  fetchAddLPViews,
  receiveAddLPViews,
  fetchAddLPViewsError
] = createAsyncActions(
  'ADD_LP_VIEWS',
  ({  id }) => ({  id }),
  ({ data }) => ({ data  })
);

export const addLPViewsWorkFlow= (userId, id) => {
  const fetchPromise = StemProgram.addLPViews(userId, id);

  return runAsyncWorkflow({
    fetch: fetchAddLPViews,
    receive: receiveAddLPViews,
    error: fetchAddLPViewsError
  }, fetchPromise, {id})
};

export const [
  fetchAddBookMark,
  receiveAddBookMark,
  fetchAddBookMarkError
] = createAsyncActions(
  'ADD_BOOKMARK',
  ({  id }) => ({  id }),
  ({ data }) => ({ data  })
);

export const addBookMarkWorkFlow= (userId, id) => {
  const fetchPromise = StemProgram.addBookMark(userId, id);

  return runAsyncWorkflow({
    fetch: fetchAddBookMark,
    receive: receiveAddBookMark,
    error: fetchAddBookMarkError
  }, fetchPromise, {id})
};

export const [
  fetchDeleteBookMark,
  receiveDeleteBookMark,
  fetchDeleteBookMarkError
] = createAsyncActions(
  'UPDATE_BOOKMARK',
  ({  id }) => ({  id }),
  ({ data }) => ({ data  })
);

export const deleteBookMarkWorkFlow= (userId, id) => {
  const fetchPromise = StemProgram.deleteBookMark(userId, id);

  return runAsyncWorkflow({
    fetch: fetchDeleteBookMark,
    receive: receiveDeleteBookMark,
    error: fetchDeleteBookMarkError
  }, fetchPromise, {id})
};

export const [
  fetchBookMarks,
  receiveBookMarks,
  fetchBookMarksError
] = createAsyncActions(
  'GET_BOOKMARKS',
  () => {},
  ({ bookmarks }) => ({ bookmarks  })
);

export const getBookMarksWorkFlow= (userId) => {
  const fetchPromise = StemProgram.getBookMarks(userId);

  return runAsyncWorkflow({
    fetch: fetchBookMarks,
    receive: receiveBookMarks,
    error: fetchBookMarksError
  }, fetchPromise)
};

export const [
  fetchRecommended,
  receiveRecommended,
  fetchRecommendedError
] = createAsyncActions(
  'GET_RECOMMENDED_LP',
  () => {},
  ({ data }) => ({ data  })
);

export const getRecommendedWorkFlow= (userId, locale) => {
  const fetchPromise = StemProgram.getRecommended(userId, locale);

  return runAsyncWorkflow({
    fetch: fetchRecommended,
    receive: receiveRecommended,
    error: fetchRecommendedError
  }, fetchPromise)
};

export const [
  fetchStemLiteracyStaticData,
  receiveStemLiteracyStaticData,
  fetchStemLiteracyStaticDataError
] = createAsyncActions(
  'GET_STATIC_STEM_LITERACY_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getStemLiteracyStaticData= (locale) => {
  const fetchPromise = StemProgram.getStemLiteracyStaticData(locale);

  return runAsyncWorkflow({
    fetch: fetchStemLiteracyStaticData,
    receive: receiveStemLiteracyStaticData,
    error: fetchStemLiteracyStaticDataError
  }, fetchPromise)
};

export const [
  fetchStemGroupingStaticData,
  receiveStemGroupingStaticData,
  fetchStemGroupingStaticDataError
] = createAsyncActions(
  'GET_STATIC_GROUPING_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getStemGroupingStaticData= (locale) => {
  const fetchPromise = StemProgram.getStemGroupingStaticData(locale);

  return runAsyncWorkflow({
    fetch: fetchStemGroupingStaticData,
    receive: receiveStemGroupingStaticData,
    error: fetchStemGroupingStaticDataError
  }, fetchPromise)
};

export const [
  fetchAllNewsData,
  receiveAllNewsData,
  fetchAllNewsDataError
] = createAsyncActions(
  'GET_ALL_NEWS_DATA',
  () => {},
  ({ data, meta }) => ({ data, meta })
);

export const getAllNewsData= (limit) => {
  const fetchPromise = StemProgram.getAllNewsData(limit);

  return runAsyncWorkflow({
    fetch: fetchAllNewsData,
    receive: receiveAllNewsData,
    error: fetchAllNewsDataError
  }, fetchPromise)
}

export const [
  fetchStemExploreStaticData,
  receiveStemExploreStaticData,
  fetchStemExploreStaticDataError
] = createAsyncActions(
  'GET_STATIC_STEM_EXPLORE_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getStemExploreStaticData= (subject, locale) => {
  const fetchPromise = StemProgram.getStemExploreStaticData(subject, locale);

  return runAsyncWorkflow({
    fetch: fetchStemExploreStaticData,
    receive: receiveStemExploreStaticData,
    error: fetchStemExploreStaticDataError
  }, fetchPromise)
};


export const [
  fetchGetStoriesStaticData,
  receiveGetStoriesStaticData,
  fetchGetStoriesStaticDataError
] = createAsyncActions(
  'GET_STATIC_STEM_STORIES_DATA',
  () => {},
  ({ data }) => ({ data })
);

export const getStoriesStaticData= (slug, subject, locale) => {
  const fetchPromise = StemProgram.getStoriesStaticData(slug, subject, locale);

  return runAsyncWorkflow({
    fetch: fetchGetStoriesStaticData,
    receive: receiveGetStoriesStaticData,
    error: fetchGetStoriesStaticDataError
  }, fetchPromise)
};


export const [
  fetchAllCampaignsData,
  receiveAllCampaignsData,
  fetchAllCampaignsDataError
] = createAsyncActions(
  'GET_ALL_CAMPAIGN_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getAllCampaignsData= () => {
  const fetchPromise = StemProgram.getAllCampaignsData();

  return runAsyncWorkflow({
    fetch: fetchAllCampaignsData,
    receive: receiveAllCampaignsData,
    error: fetchAllCampaignsDataError
  }, fetchPromise)
};

export const [
  fetchAllProgramCampaignsData,
  receiveAllProgramCampaignsData,
  fetchAllProgramCampaignsDataError
] = createAsyncActions(
  'GET_ALL_PROGRAM_CAMPAIGN_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getAllProgramCampaignsData= () => {
  const fetchPromise = StemProgram.getAllProgramCampaignsData();

  return runAsyncWorkflow({
    fetch: fetchAllProgramCampaignsData,
    receive: receiveAllProgramCampaignsData,
    error: fetchAllProgramCampaignsDataError
  }, fetchPromise)
};

export const [
  fetchAllImpactsData,
  receiveAllImpactsData,
  fetchAllImpactsDataError
] = createAsyncActions(
  'GET_ALL_IMPACTS_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getAllImpactsData= () => {
  const fetchPromise = StemProgram.getAllImpactsData();

  return runAsyncWorkflow({
    fetch: fetchAllImpactsData,
    receive: receiveAllImpactsData,
    error: fetchAllImpactsDataError
  }, fetchPromise)
};

export const [
  fetchIndCampaignsData,
  receiveIndCampaignsData,
  fetchIndCampaignsDataError
] = createAsyncActions(
  'GET_IND_CAMPAIGN_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getIndCampaignsData= (slug) => {
  const fetchPromise = StemProgram.getIndCampaignsData(slug);

  return runAsyncWorkflow({
    fetch: fetchIndCampaignsData,
    receive: receiveIndCampaignsData,
    error: fetchIndCampaignsDataError
  }, fetchPromise)
};

export const [
  fetchIndProgramCampaignsData,
  receiveIndProgramCampaignsData,
  fetchIndProgramCampaignsDataError
] = createAsyncActions(
  'GET_IND_PROGRAM_CAMPAIGN_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getIndProgramCampaignsData= (slug, type) => {
  const fetchPromise = StemProgram.getIndProgramCampaignsData(slug, type);

  return runAsyncWorkflow({
    fetch: fetchIndProgramCampaignsData,
    receive: receiveIndProgramCampaignsData,
    error: fetchIndProgramCampaignsDataError
  }, fetchPromise)
};

export const [
  fetchStemMoocData,
  receiveStemMoocData,
  fetchStemMoocDataError
] = createAsyncActions(
  'GET_STEM_MOOC',
  () => {},
  ({ data }) => ({ data  })
);

export const getStemMoocDataWorkFlow= (locale) => {
  const fetchPromise = StemProgram.getStemMoocData(locale);

  return runAsyncWorkflow({
    fetch: fetchStemMoocData,
    receive: receiveStemMoocData,
    error: fetchStemMoocDataError
  }, fetchPromise)
};

export const [
  fetchStemMoocModuleData,
  receiveStemMoocModuleData,
  fetchStemMoocModuleDataError
] = createAsyncActions(
  'GET_STEM_MOOC_MODULE',
  () => {},
  ({ data }) => ({ data  })
);

export const getStemMoocModuleDataWorkFlow= (id, locale) => {
  const fetchPromise = StemProgram.getStemMoocModuleData(id, locale);

  return runAsyncWorkflow({
    fetch: fetchStemMoocModuleData,
    receive: receiveStemMoocModuleData,
    error: fetchStemMoocModuleDataError
  }, fetchPromise)
};

export const [
  fetchEnrolStemUser,
  receiveEnrolStemUser,
  fetchEnrolStemUserError
] = createAsyncActions(
  'ENROL_STEM',
  () => {},
  ({ ok }) => ({ ok  })
);

export const enrolStemUserWorkFlow = (data, locale) => {
  const fetchPromise = StemProgram.enrolStemUser(data, locale);

  return runAsyncWorkflow({
    fetch: fetchEnrolStemUser,
    receive: receiveEnrolStemUser,
    error: fetchEnrolStemUserError
  }, fetchPromise)
};

export const [
  fetchStemEnrolData,
  receiveStemEnrolData,
  fetchStemEnrolDataError
] = createAsyncActions(
  'GET_STEM_ENROLMENT',
  () => {},
  ({ ok, data }) => ({ ok, data  })
);

export const getStemEnrolmentWorkFlow = (locale) => {
  const fetchPromise = StemProgram.getStemEnrolment(locale);

  return runAsyncWorkflow({
    fetch: fetchStemEnrolData,
    receive: receiveStemEnrolData,
    error: fetchStemEnrolDataError
  }, fetchPromise)
};

export const [
  fetchSetVideoView,
  receiveSetVideoView,
  fetchSetVideoViewError
] = createAsyncActions(
  'SET_VIDEO_VIEWS',
  () => {},
  ({ ok }) => ({ ok  })
);

export const setVideoViewWorkFlow = (module, video, locale, programType) => {
  const fetchPromise = StemProgram.setVideoView(module, video, locale, programType);

  return runAsyncWorkflow({
    fetch: fetchSetVideoView,
    receive: receiveSetVideoView,
    error: fetchSetVideoViewError
  }, fetchPromise)
};

export const [
  fetchAllPressReleaseData,
  receiveAllPressReleaseData,
  fetchAllPressReleaseDataError
] = createAsyncActions(
  'GET_ALL_PRESS_RELEASE_DATA',
  () => {},
  ({ data, meta }) => ({ data, meta })
);

export const getAllPressReleaseData= (limit) => {
  const fetchPromise = StemProgram.getAllPressReleaseData(limit);
    return runAsyncWorkflow({
    fetch: fetchAllPressReleaseData,
    receive: receiveAllPressReleaseData,
    error: fetchAllPressReleaseDataError
  }, fetchPromise)
};

export const [
  fetchFlpMoocData,
  receiveFlpMoocData,
  fetchFlpMoocDataError
] = createAsyncActions(
  'GET_FLP_MOOC',
  () => {},
  ({ data }) => ({ data  })
);

export const getFlpMoocDataWorkFlow= (locale) => {
  const fetchPromise = StemProgram.getFlpMoocData(locale);

  return runAsyncWorkflow({
    fetch: fetchFlpMoocData,
    receive: receiveFlpMoocData,
    error: fetchFlpMoocDataError
  }, fetchPromise)
};

export const [
  fetchIndPressReleaseData,
  receiveIndPressReleaseData,
  fetchIndPressReleaseDataError
] = createAsyncActions(
  'GET_IND_PRESS_RELEASE_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getIndPressReleaseData= (slug) => {
  const fetchPromise = StemProgram.getIndPressReleaseData(slug);

  return runAsyncWorkflow({
    fetch: fetchIndPressReleaseData,
    receive: receiveIndPressReleaseData,
    error: fetchIndPressReleaseDataError
  }, fetchPromise)
};

export const [
  fetchFlpMoocModuleData,
  receiveFlpMoocModuleData,
  fetchFlpMoocModuleDataError
] = createAsyncActions(
  'GET_FLP_MOOC_MODULE',
  () => {},
  ({ data }) => ({ data  })
);

export const getFlpMoocModuleDataWorkFlow= (id, locale) => {
  const fetchPromise = StemProgram.getFlpMoocModuleData(id, locale);

  return runAsyncWorkflow({
    fetch: fetchFlpMoocModuleData,
    receive: receiveFlpMoocModuleData,
    error: fetchFlpMoocModuleDataError
  }, fetchPromise)
};

export const [
  fetchIndNewsData,
  receiveIndNewsData,
  fetchIndNewsDataError
] = createAsyncActions(
  'GET_IND_NEWS_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getIndNewsData= (slug) => {
  const fetchPromise = StemProgram.getIndNewsData(slug);

  return runAsyncWorkflow({
    fetch: fetchIndNewsData,
    receive: receiveIndNewsData,
    error: fetchIndNewsDataError
  }, fetchPromise)
};

export const [
  fetchEnrolFlpMoocUser,
  receiveEnrolFlpMoocUser,
  fetchEnrolFlpMoocUserError
] = createAsyncActions(
  'ENROL_FLP_MOOC',
  () => {},
  ({ ok }) => ({ ok  })
);

export const enrolFlpMoocUserWorkFlow = (data, locale) => {
  const fetchPromise = StemProgram.enrolFlpMoocUser(data, locale);

  return runAsyncWorkflow({
    fetch: fetchEnrolFlpMoocUser,
    receive: receiveEnrolFlpMoocUser,
    error: fetchEnrolFlpMoocUserError
  }, fetchPromise)
};

export const [
  fetchFlpMoocEnrolData,
  receiveFlpMoocEnrolData,
  fetchFlpMoocEnrolDataError
] = createAsyncActions(
  'GET_FLP_MOOC_ENROLMENT',
  () => {},
  ({ ok, data }) => ({ ok, data  })
);

export const getFlpMoocEnrolmentWorkFlow = (locale) => {
  const fetchPromise = StemProgram.getFlpMoocEnrolment(locale);

  return runAsyncWorkflow({
    fetch: fetchFlpMoocEnrolData,
    receive: receiveFlpMoocEnrolData,
    error: fetchFlpMoocEnrolDataError
  }, fetchPromise)
};

export const [
  fetchEnrollPledgeCampaign,
  receiveEnrollPledgeCampaign,
  fetchEnrollPledgeCampaignError
] = createAsyncActions(
  'ENROLL_PLEDGE_CAMPAIGN',
  ({details}) => ({ details}),
  //({ ok, data }) => ({ ok, data })
);

export const enrollPledgeCampaign = ( details, org) => {
  const fetchPromise = StemProgram.enrollPledgeCampaign(details, org);
  
  return runAsyncWorkflow({
    fetch: fetchEnrollPledgeCampaign,
    receive: receiveEnrollPledgeCampaign,
    error:  fetchEnrollPledgeCampaignError
  }, fetchPromise);
};

export const [
  fetchFlpMoocAllModules,
  receiveFlpMoocAllModules,
  fetchFlpMoocAllModulesError
] = createAsyncActions(
  'GET_FLP_MOOC_ALL_MODULES',
  () => {},
  ({ ok, data }) => ({ ok , data })
);

export const getFlpMoocAllModules = (locale) => {
  const fetchPromise = StemProgram.getFlpMoocAllModules(locale);

  return runAsyncWorkflow({
    fetch: fetchFlpMoocAllModules,
    receive: receiveFlpMoocAllModules,
    error: fetchFlpMoocAllModulesError
  }, fetchPromise);
};

export const [
  fetchFlpMoocCertDownload,
  recieveFlpMoocCertDownload,
  fetchFlpMoocCertDownloadError
] = createAsyncActions(
  'GET_FLP_MOOC_CERTIFICATE',
  ({ enrollId, name, moduleId, moduleName, schoolName, locale }) => ({ enrollId, name, moduleId, moduleName, schoolName, locale }),
  ({  ok, url, msg}) => ({  ok, url, msg})
);

export const getFlpMoocCertificate =  (enrollId, name, moduleId, moduleName, schoolName, locale, moduleIndex) => {
  const fetchPromise = StemProgram.getFlpMoocCertificateData(enrollId, name, moduleId, moduleName, schoolName, locale, moduleIndex);

  return runAsyncWorkflow({
    fetch: fetchFlpMoocCertDownload,
    receive: recieveFlpMoocCertDownload,
    error:   fetchFlpMoocCertDownloadError
  }, fetchPromise)
}
  export const [
    fetchGetPledgeEnroll,
    receiveGetPledgeEnroll,
    fetchGetPledgeEnrollError
  ] = createAsyncActions(
    'GET_PLEDGE_CAMPAIGN_ENROLL',
    () => {},
    ({ ok, pledge_to_read_data, ptr_partner_details, ptr_user_details, stats }) => ({ ok, pledge_to_read_data, ptr_partner_details, ptr_user_details, stats })
  );
  
  export const getPledgeCampaignEnroll = (org) => {
    const fetchPromise = StemProgram.getPledgeCampaignEnroll(org);
  
    return runAsyncWorkflow({
      fetch: fetchGetPledgeEnroll,
      receive: receiveGetPledgeEnroll,
      error: fetchGetPledgeEnrollError
    }, fetchPromise);
  };

  export const [
    fetchStaticPledgeData,
    receiveStaticPledgeData,
    fetchStaticPledgeDataError
  ] = createAsyncActions(
    'GET_STATIC_PLEDGE_DATA',
    () => {},
    ({ ok, data }) => ({ ok , data })
  );
  
  export const getStaticPledgeData = (locale) => {
    const fetchPromise = StemProgram.getStaticPledgeData(locale);
  
    return runAsyncWorkflow({
      fetch: fetchStaticPledgeData,
      receive: receiveStaticPledgeData,
      error: fetchStaticPledgeDataError
    }, fetchPromise);
  };

  export const [
    fetchStaticSubCampaignData,
    receiveStaticSubCampaignData,
    fetchStaticSubCampaignDataError
  ] = createAsyncActions(
    'GET_STATIC_SUB_CAMPAIGN_DATA',
    () => {},
    ({ ok, data }) => ({ ok , data })
  );
  
  export const getStaticSubCampaignData = (locale, org) => {
    const fetchPromise = StemProgram.getStaticSubCampaignData(locale, org);
  
    return runAsyncWorkflow({
      fetch: fetchStaticSubCampaignData,
      receive: receiveStaticSubCampaignData,
      error: fetchStaticSubCampaignDataError
    }, fetchPromise);
  };

  export const [
    fetchStaticPledgePartnerData,
    receiveStaticPledgePartnerData,
    fetchStaticPledgePartnerDataError
  ] = createAsyncActions(
    'GET_STATIC_PLEDGE_PARTNER_DATA',
    () => {},
    ({ ok, data }) => ({ ok , data })
  );
  
  export const getStaticPledgePartnerData = (locale) => {
    const fetchPromise = StemProgram.getStaticPledgePartnerData(locale);
  
    return runAsyncWorkflow({
      fetch: fetchStaticPledgePartnerData,
      receive: receiveStaticPledgePartnerData,
      error: fetchStaticPledgePartnerDataError
    }, fetchPromise);
  };

  export const [
    fetchHeroActivity,
    receiveHeroActivity,
    fetchHeroActivityError
  ] = createAsyncActions(
    'GET_HERO_ACTIVITY',
    ({org}) => ({org}),
    ({ ok, data, org }) => ({ ok , data, org })
  );
  
  export const getHeroActivity = (locale, org) => {
    const fetchPromise = StemProgram.getHeroActivity(locale, org);
  
    return runAsyncWorkflow({
      fetch: fetchHeroActivity,
      receive: receiveHeroActivity,
      error: fetchHeroActivityError
    }, fetchPromise,
    { org }
    );
  };

  export const [
    fetchFlagshipVideos,
    receiveFlagshipVideos,
    fetchFlagshipVideosError
  ] = createAsyncActions(
    'GET_FLAGSHIP_VIDEOS',
    () => {},
    ({ ok, data }) => ({ ok , data })
  );
  
  export const getFlagshipVideos = (locale) => {
    const fetchPromise = StemProgram.getFlagshipVideos(locale);
  
    return runAsyncWorkflow({
      fetch: fetchFlagshipVideos,
      receive: receiveFlagshipVideos,
      error: fetchFlagshipVideosError
    }, fetchPromise);
  };

  export const [
    markPTRNotifAsRead,
    markPTRNotifAsReadResponse,
    markPTRNotifAsReadError
  ] = createAsyncActions(
    'MARK_ONE_NOTIFICATIONS_AS_READ',
    () => {},
    (data) => data
  );
  
  export const markPTRNotifAsReadWorkFlow = () => {
    const fetchPromise = StemProgram.markPTRNotifAsRead();
    
    return runAsyncWorkflow({
      fetch: markPTRNotifAsRead,
      receive: markPTRNotifAsReadResponse,
      error: markPTRNotifAsReadError
    }, fetchPromise);
  }

  export const [
    fetchStemMoocCertDownload,
    recieveStemMoocCertDownload,
    fetchStemMoocCertDownloadError
  ] = createAsyncActions(
    'GET_STEM_MOOC_CERTIFICATE',
    ({ enrollId, name, moduleId, moduleName, schoolName, locale }) => ({ enrollId, name, moduleId, moduleName, schoolName, locale }),
    ({  ok, url, msg}) => ({  ok, url, msg})
  );
  
  export const getStemMoocCertificate =  (enrollId, name, moduleId, moduleName, schoolName, locale, moduleIndex) => {
    const fetchPromise = StemProgram.getStemMoocCertificateData(enrollId, name, moduleId, moduleName, schoolName, locale, moduleIndex);
  
    return runAsyncWorkflow({
      fetch: fetchStemMoocCertDownload,
      receive: recieveStemMoocCertDownload,
      error:   fetchStemMoocCertDownloadError
    }, fetchPromise)
  }

  export const [
    fetchStemMoocAllModules,
    receiveStemMoocAllModules,
    fetchStemMoocAllModulesError
  ] = createAsyncActions(
    'GET_STEM_MOOC_ALL_MODULES',
    () => {},
    ({ ok, data }) => ({ ok , data })
  );
  
  export const getStemMoocAllModules = (locale) => {
    const fetchPromise = StemProgram.getStemMoocAllModules(locale);
  
    return runAsyncWorkflow({
      fetch: fetchStemMoocAllModules,
      receive: receiveStemMoocAllModules,
      error: fetchStemMoocAllModulesError
    }, fetchPromise);
  };

  export const [
    fetchPartnerPtrForm,
    receivePartnerPtrForm,
    fetchPartnerPtrFormError
  ] = createAsyncActions(
    'PARTNER_PTR_FORM',
    ({certDetails, locale, certificate}) => ({ certDetails, locale, certificate}),
  );
  
  export const partnerPtrForm = ( certDetails, locale, certificate) => {
    const fetchPromise = StemProgram.partnerPtrForm(certDetails, locale, certificate);
    
    return runAsyncWorkflow({
      fetch: fetchPartnerPtrForm,
      receive: receivePartnerPtrForm,
      error:  fetchPartnerPtrFormError
    }, fetchPromise);
  };

export const [
  fetchStemSearchResults,
  receiveStemSearchResults,
  fetchStemSearchResultsError
] = createAsyncActions(
  'STEM_SEARCH_RESULTS',
  () => {},
  ({ok, hits, data}) => ({ok, hits, data}),
);

export const getStemSearchResults = ( query, grade, subject, locale) => {
  const fetchPromise = StemProgram.getStemSearchResults( query, grade, subject, locale);
  
  return runAsyncWorkflow({
    fetch: fetchStemSearchResults,
    receive: receiveStemSearchResults,
    error:  fetchStemSearchResultsError
  }, fetchPromise);
};

export const [
  fetchGcrReadingCertificate,
  receiveGcrReadingCertificate,
  fetchGcrReadingCertificateError
] = createAsyncActions(
  'GCR_READING_CERTIFICATE',
  ({name, badge, locale, org, data}) => ({ name, badge, locale, org, data}),
);

export const getGcrReadingCertificate = ( name, badge, locale, org, data) => {
  const fetchPromise = StemProgram.getGcrReadingCertificate(name, badge, locale, org, data);
  
  return runAsyncWorkflow({
    fetch: fetchGcrReadingCertificate,
    receive: receiveGcrReadingCertificate,
    error:  fetchGcrReadingCertificateError
  }, fetchPromise);
};

export const [
  fetchStaticSubGcrData,
  receiveStaticSubGcrData,
  fetchStaticSubGcrDataError
] = createAsyncActions(
  'SUB_GCR_DATA',
  () => {},
  ({data}) => ({data}),
);

export const getStaticSubGcrData = () => {
  const fetchPromise = StemProgram.getStaticSubGcrData();
  
  return runAsyncWorkflow({
    fetch: fetchStaticSubGcrData,
    receive: receiveStaticSubGcrData,
    error:  fetchStaticSubGcrDataError
  }, fetchPromise);
};

export const [
  fetchGetImpactStaticData,
  receiveGetImpactStaticData,
  fetchGetImpactStaticDataError
] = createAsyncActions(
  'IMPACT_STATIC_DATA',
  () => {},
  ({data}) => ({data}),
);

export const getImpactStaticData = (slug) => {
  const fetchPromise = StemProgram.getImpactStaticData(slug);
  
  return runAsyncWorkflow({
    fetch: fetchGetImpactStaticData,
    receive: receiveGetImpactStaticData,
    error:  fetchGetImpactStaticDataError
  }, fetchPromise);
};

export const [
  fetchGetAwardsStaticData,
  receiveGetAwardsStaticData,
  fetchGetAwardsStaticDataError
] = createAsyncActions(
  'AWARDS_STATIC_DATA',
  () => {},
  ({data}) => ({data}),
);

export const getAwardsStaticData = () => {
  const fetchPromise = StemProgram.getAwardsStaticData();
  
  return runAsyncWorkflow({
    fetch: fetchGetAwardsStaticData,
    receive:   receiveGetAwardsStaticData,
    error:  fetchGetAwardsStaticDataError
  }, fetchPromise);

};

export const [
  fetchGetOdosEnroll,
  receiveGetOdosEnroll,
  fetchGetOdosEnrollError
] = createAsyncActions(
  'GET_ODOS_CAMPAIGN_ENROLL',
  () => {},
  ({ ok, odos_enrollment_details, odos_user_details }) => ({ ok, odos_enrollment_details, odos_user_details })
);

export const getOdosCampaignEnroll = () => {
  const fetchPromise = StemProgram.getOdosCampaignEnroll();

  return runAsyncWorkflow({
    fetch: fetchGetOdosEnroll,
    receive: receiveGetOdosEnroll,
    error: fetchGetOdosEnrollError
  }, fetchPromise);
};

export const [
  fetchEnrollOdosCampaign,
  receiveEnrollOdosCampaign,
  fetchEnrollOdosCampaignError
] = createAsyncActions(
  'ENROLL_ODOS_CAMPAIGN',
  ({details}) => ({ details}),
  ({ ok, odos_data }) => ({ ok, odos_data })

);

export const enrollOdosCampaign = ( details) => {
  console.log('action', details)
  const fetchPromise = StemProgram.enrollOdosCampaign(details);
  
  return runAsyncWorkflow({
    fetch: fetchEnrollOdosCampaign,
    receive: receiveEnrollOdosCampaign,
    error:  fetchEnrollOdosCampaignError
  }, fetchPromise);
};

export const [
  fetchOdosUserDetails,
  receiveOdosUserDetails,
  fetchOdosUserDetailsError
] = createAsyncActions(
  'ODOS_USER_DETAILS',
  ({userDetails}) => ({ userDetails}),
  ({ error, message}) => ({  error, message})
);

export const odosUserDetailsWorkFlow = ( userDetails) => {
  const fetchPromise = StemProgram.odosUserDetails(userDetails);
  
  return runAsyncWorkflow({
    fetch: fetchOdosUserDetails,
    receive: receiveOdosUserDetails,
    error:  fetchOdosUserDetailsError
  }, fetchPromise);
};

export const [
  fetchOdosCertificate,
  receiveOdosCertificate,
  fetchOdosCertificateError
] = createAsyncActions(
  'ODOS_CERTIFICATE',
  ({certDetails, locale}) => ({certDetails, locale}),
  ({ ok, url}) => ({  ok, url})
);

export const getOdosCertificate = (certDetails, locale) => {
  const fetchPromise = StemProgram.getOdosCertificate(certDetails, locale);
  
  return runAsyncWorkflow({
    fetch: fetchOdosCertificate,
    receive: receiveOdosCertificate,
    error:  fetchOdosCertificateError
  }, fetchPromise);
};

export const [
  fetchUploadFileToCloud,
  receiveUploadFileToCloud,
  fetchUploadFileToCloudError
] = createAsyncActions(
  'UPLOAD_TO_CLOUD',
  ({formData}) => ({formData}),
  ({ ok, url}) => ({  ok, url})
);

export const uploadFileToCloud = (formData) => {
  const fetchPromise = StemProgram.uploadFileToCloud(formData);
  
  return runAsyncWorkflow(
    {
      fetch: fetchUploadFileToCloud,
      receive: receiveUploadFileToCloud,
      error:  fetchUploadFileToCloudError
    }, 
    fetchPromise,
    { formData }
  );
};

export const [
  fetchRemoveFileFromCloud,
  receiveRemoveFileFromCloud,
  fetchRemoveFileFromCloudError
] = createAsyncActions(
  'REMOVE_FROM_CLOUD',
  ({file}) => ({file}),
  ({ ok, url}) => ({  ok, url})
);

export const removeFileFromCloud = (file) => {
  const fetchPromise = StemProgram.removeFileFromCloud(file);
  
  return runAsyncWorkflow(
    {
      fetch: fetchRemoveFileFromCloud,
      receive: receiveRemoveFileFromCloud,
      error:  fetchRemoveFileFromCloudError
    }, 
    fetchPromise
  );
};

export const [
  fetchImageAnalyze,
  receiveImageAnalyze,
  fetchImageAnalyzeError
] = createAsyncActions(
  'IMAGE_ANALYZE',
  ({file}) => ({file}),
  ({ ok, url}) => ({  ok, url})
);

export const imageAnalyze = (file) => {
  const fetchPromise = StemProgram.imageAnalyze(file);
  
  return runAsyncWorkflow(
    {
      fetch: fetchImageAnalyze,
      receive: receiveImageAnalyze,
      error:  fetchImageAnalyzeError
    }, 
    fetchPromise
  );
};

export const [
  fetchOldGcrPledgeData,
  receiveOldGcrPledgeData,
  fetchOldGcrPledgeDataError
] = createAsyncActions(
  'GET_OLD_GCR_PLEDGE_DATA',
  () => {},
  ({ ok, data }) => ({ ok , data })
);

export const getOldGcrPledgeData = (locale) => {
  const fetchPromise = StemProgram.getOldGcrPledgeData(locale);

  return runAsyncWorkflow({
    fetch: fetchOldGcrPledgeData,
    receive: receiveOldGcrPledgeData,
    error: fetchOldGcrPledgeDataError
  }, fetchPromise);
};

export const [
  fetchOdosCertData,
  receiveOdosCertData,
  fetchOdosCertDataError
] = createAsyncActions(
  'GET_ODOS_CERT_DATA',
  () => {},
  ({ ok, data }) => ({ ok , data })
);

export const getOdosCertData = (locale) => {
  const fetchPromise = StemProgram.getOdosCertData(locale);

  return runAsyncWorkflow({
    fetch: fetchOdosCertData,
    receive: receiveOdosCertData,
    error: fetchOdosCertDataError
  }, fetchPromise);
};

export const [
  fetchGetCareerHomePageStaticData,
  receiveGetCareerHomePageStaticData,
  fetchGetCareerHomePageStaticDataError
] = createAsyncActions(
  'CAREER_HOME_STATIC_DATA',
  () => {},
  ({data}) => ({data}),
);

export const getCareerHomePageStaticData = () => {
  const fetchPromise = StemProgram.getCareerHomePageStaticData();
  
  return runAsyncWorkflow({
    fetch: fetchGetCareerHomePageStaticData,
    receive:   receiveGetCareerHomePageStaticData,
    error:  fetchGetCareerHomePageStaticDataError
  }, fetchPromise);

};

export const [
  fetchGetCareerDetailPageStaticData,
  receiveGetCareerDetailPageStaticData,
  fetchGetCareerDetailPageStaticDataError
] = createAsyncActions(
  'CAREER_DETAIL_STATIC_DATA',
  () => {},
  ({data}) => ({data}),
);

export const getCareerDetailPageStaticData = (slug) => {
  const fetchPromise = StemProgram.getCareerDetailPageStaticData(slug);
  
  return runAsyncWorkflow({
    fetch: fetchGetCareerDetailPageStaticData,
    receive:   receiveGetCareerDetailPageStaticData,
    error:  fetchGetCareerDetailPageStaticDataError
  }, fetchPromise);

};

export const [
  fetchResourcesLandingPageData,
  receiveResourcesLandingPageData,
  fetchResourcesLandingPageDataError
] = createAsyncActions(
  'RESOURCES_LANDING_PAGE_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getResourcesLandingPageData = (slug, locale) => {
  const fetchPromise = StemProgram.getResourcesLandingPageData(slug, locale);
  
  return runAsyncWorkflow({
    fetch: fetchResourcesLandingPageData,
    receive: receiveResourcesLandingPageData,
    error: fetchResourcesLandingPageDataError
  }, fetchPromise);
};

export const [
  fetchResourceStories,
  receiveResourceStories,
  fetchResourceStoriesError
] = createAsyncActions(
  'RESOURCE_STORIES',
  () => {},
  ({ ok, stories }) => ({ok, data: stories })
);

export const getResourceStories = (category, language, isAudio) => {
  const fetchPromise = StemProgram.getResourceStories(category, language, isAudio);
  
  return runAsyncWorkflow({
    fetch: fetchResourceStories,
    receive: receiveResourceStories,
    error: fetchResourceStoriesError
  }, fetchPromise);
};

export const [
  fetchResourceStoriesLanguages,
  receiveResourceStoriesLanguages,
  fetchResourceStoriesLanguagesError
] = createAsyncActions(
  'RESOURCE_STORIES_LANGUAGES',
  () => {},
  ({ ok, data }) => ({ ok, data  })
);

export const getResourceStoriesLanguages = (category, isAudio) => {
  const fetchPromise = StemProgram.getResourceStoriesLanguages(category, isAudio);
  
  return runAsyncWorkflow({
    fetch: fetchResourceStoriesLanguages,
    receive: receiveResourceStoriesLanguages,
    error: fetchResourceStoriesLanguagesError
  }, fetchPromise);
};

export const [
  fetchAllCampaignRegistrations,
  receiveAllCampaignRegistrations,
  fetchAllCampaignRegistrationsError
] = createAsyncActions(
  'ALL_CAMPAIGN_REGISTRATIONS',
  () => {},
  ({ ok, data }) => ({ ok, data  })
);

export const getAllCampaignRegistrations = () => {
  const fetchPromise = StemProgram.getAllCampaignRegistrations();
  
  return runAsyncWorkflow({
    fetch: fetchAllCampaignRegistrations,
    receive: receiveAllCampaignRegistrations,
    error: fetchAllCampaignRegistrationsError
  }, fetchPromise);
};

export const [
  fetchEventCertificateStaticData,
  receiveEventCertificateStaticData,
  fetchEventCertificateStaticDataError
] = createAsyncActions(
  'EVENT_CERTIFICATE_STATIC_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getEventCertificateStaticData = (eventType, lang) => {
  const fetchPromise = StemProgram.getEventCertificateStaticData(eventType, lang);
  
  return runAsyncWorkflow({
    fetch: fetchEventCertificateStaticData,
    receive: receiveEventCertificateStaticData,
    error: fetchEventCertificateStaticDataError
  }, fetchPromise);
};

export const [
  fetchEventCertificateDetails,
  receiveEventCertificateDetails,
  fetchEventCertificateDetailsError
] = createAsyncActions(
  'EVENT_CERTIFICATE_DETAILS',
  ({eventType}) => ({ eventType}),
  ({ ok, data}) => ({  ok, data})
);

export const getEventCertificateDetails = ( eventType) => {
  const fetchPromise = StemProgram.getEventCertificateDetails(eventType);
  
  return runAsyncWorkflow({
    fetch: fetchEventCertificateDetails,
    receive: receiveEventCertificateDetails,
    error:  fetchEventCertificateDetailsError
  }, fetchPromise);
};

export const [
  fetchEventCertificateEnroll,
  receiveEventCertificateEnroll,
  fetchEventCertificateEnrollError
] = createAsyncActions(
  'EVENT_CERTIFICATE_ENROLL',
  ({eventType, userDetails, language}) => ({eventType, userDetails, language}),
  ({ ok}) => ({ ok})
);

export const eventCertificateEnroll = (eventType, userDetails, language) => {
  const fetchPromise = StemProgram.eventCertificateEnroll(eventType, userDetails, language);
  
  return runAsyncWorkflow({
    fetch: fetchEventCertificateEnroll,
    receive: receiveEventCertificateEnroll,
    error:  fetchEventCertificateEnrollError
  }, fetchPromise);
};

export const [
  fetchEventCertificate,
  receiveEventCertificate,
  fetchEventCertificateError
] = createAsyncActions(
  'EVENT_CERTIFICATE',
  ({certDetails, locale, id, eventType}) => ({certDetails, locale, id, eventType}),
  ({ ok, url}) => ({  ok, url})
);

export const getEventCertificate = (certDetails, locale, id, eventType) => {
  const fetchPromise = StemProgram.getEventCertificate(certDetails, locale, id, eventType);
  
  return runAsyncWorkflow({
    fetch: fetchEventCertificate,
    receive: receiveEventCertificate,
    error:  fetchEventCertificateError
  }, fetchPromise);
};

export const [
  fetchEventLangSupportData,
  receiveEventLangSupportData,
  fetchEventLangSupportDataError
] = createAsyncActions(
  'EVENT_LANG_SUPPORT_DATA',
  () => {},
  ({ data }) => ({ data  })
);

export const getEventLangSupportData = (eventType) => {
  const fetchPromise = StemProgram.getEventLangSupportData(eventType);
  
  return runAsyncWorkflow({
    fetch: fetchEventLangSupportData,
    receive: receiveEventLangSupportData,
    error: fetchEventLangSupportDataError
  }, fetchPromise);
};


// WEBPACK FOOTER //
// ./src/redux/stemActions.js